export default {
    KEYCLOAK: 'keycloak',
};
